// skipcq: JS-W1028
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import BeerIngestionRunDetailBody, { RunTechnicalIdsPopover } from './BeerIngestionRunDetailBody';

export default function BeerIngestionRunDetailDialog({
  open,
  run,
  snapshot = null,
  comparison = null,
  review = null,
  breweryId = '',
  breweryName = '',
  previousRun = null,
  loading = false,
  retryLoading = false,
  onClose,
  onOpenPreviousRun,
  onRetry,
  onReviewUpdated,
}) {
  const handlePreviousRunClick = useCallback(() => {
    if (previousRun) {
      onOpenPreviousRun(previousRun);
    }
  }, [onOpenPreviousRun, previousRun]);

  if (!open) {
    return null;
  }

  if (!run && !loading) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Typography variant="h6" component="h2">
          Ingestion run
        </Typography>
        {!loading && run ? <RunTechnicalIdsPopover run={run} /> : null}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={32} aria-label="Loading ingestion run" />
          </Box>
        ) : null}
        {!loading && run ? (
          <BeerIngestionRunDetailBody
            run={run}
            snapshot={snapshot}
            comparison={comparison}
            review={review}
            breweryId={breweryId}
            breweryName={breweryName}
            previousRun={previousRun}
            onPreviousRunClick={handlePreviousRunClick}
            onReviewUpdated={onReviewUpdated}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        {!loading && onRetry ? (
          <Button onClick={onRetry} disabled={retryLoading}>
            Retry processing
          </Button>
        ) : null}
        <Button onClick={onClose}>
          {loading ? 'Cancel' : 'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BeerIngestionRunDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  run: PropTypes.object,
  snapshot: PropTypes.object,
  comparison: PropTypes.object,
  review: PropTypes.object,
  breweryId: PropTypes.string,
  breweryName: PropTypes.string,
  previousRun: PropTypes.object,
  loading: PropTypes.bool,
  retryLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onOpenPreviousRun: PropTypes.func,
  onRetry: PropTypes.func,
  onReviewUpdated: PropTypes.func,
};
